import request from '../../http/request'
import { getPreUrl } from '../../utils/common'
import { isExtranetHostname } from '@/utils/hostEnv'
const preUrl = getPreUrl('8082')

export const readNfcUid = params => {
  // return request.post(`${process.env.REACT_APP_API_MAC_URL}/pc/nfc/uid`, params, {
  //   nfc: true,
  //   noSpin: true
  // })
  return request.get(`${process.env.REACT_APP_API_MAC_URL}/pc/nfc/uid`, {
    params,
    nfc: true,
    noSpin: true
  })
}

export const getTagTypeByUpc = (params, queryHeader, noSpin) => {
  // 内网访问接口
  let url = `${preUrl}/nfc-clc-service/api/nfc/tag/getByUpc`
  if (isExtranetHostname()) {
    // 外网访问接口
    url = `${process.env.REACT_APP_API_URL}/rfid-postservice/nfc/getByUpc`
  }
  return request.get(url, {
    params,
    noSpin,
    RFHeader: queryHeader
  })
}

export const sendNfcSku = params => {
  // 内网访问接口
  let url = `${preUrl}/nfc-clc-service/api/nfc/tag/binding/full`
  if (isExtranetHostname()) {
    // 外网访问接口
    url = `${process.env.REACT_APP_API_URL}/rfid-postservice/nfc/binding/full`
  }
  return request.post(url, params, {
    nfc: true,
    noSpin: true
  })
}

export const apiTagValidation = (params, queryHeader) => {
  // 内网访问接口
  let url = `${preUrl}/nfc-clc-service/api/nfc/tag/validation`
  if (isExtranetHostname()) {
    // 外网访问接口
    url = `${process.env.REACT_APP_API_URL}/rfid-postservice/nfc/validation`
  }
  return request.get(url, {
    params,
    nfc: true,
    noSpin: true,
    RFHeader: queryHeader
  })
}

// ---- Phone ----
export const reset = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_MAC_URL_PHONE}/reset`, params, {
    nfc: true,
    noSpin: true,
    RFHeader: queryHeader
  })
}

export const readNfcDataForPhone = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_MAC_URL_PHONE}/nfcdata`, {
    params,
    nfc: true,
    noSpin: true,
    RFHeader: queryHeader
  })
}

export const fullBindForPhone = (params, queryHeader) => {
  return request.post(`${preUrl}/nfc-clc-service/nfc/rf/device/full/bind`, params, {
    nfc: true,
    // noSpin: true,
    RFHeader: queryHeader
  })
}

export const readRfid = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_MAC_URL_PHONE}/rfid`, params, {
    nfc: true,
    // noSpin: true,
    RFHeader: queryHeader
  })
}

export const resetRfid = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_MAC_URL_PHONE}/resetRfid`, params, {
    nfc: true,
    // noSpin: true,
    RFHeader: queryHeader
  })
}

export const demoBind = (params, queryHeader) => {
  return request.post(`${preUrl}/nfc-clc-service/nfc/demo/bind`, params, {
    nfc: true,
    // noSpin: true,
    RFHeader: queryHeader
  })
}
